<template>
  <div class="app-container">
    <div class="filter-container">
      <div class="menu">
          <el-date-picker
          v-model="pickerTime"
          type="daterange"
          align="right"
          unlink-panels
          value-format="yyyy-MM-dd"
          format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="dateChange"
          :picker-options="pickerOptions">
          </el-date-picker>
          <el-button type="primary" class="ml" @click="exportExcelFun">导出</el-button>
      </div>
      <el-table :data="tableData"
        v-loading="loading"
        style="width: 100%" border>
        <el-table-column prop="description" label="链接应用说明" width="500"></el-table-column>
        <el-table-column prop="clickNumberTotal" label="跳转次数"> </el-table-column>
      </el-table>
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.limit"
        @pagination="getList"
      />
    </div>
  </div>
</template>
<script>
import { selectMonitorLinkRecordCount, exportExcel } from '@/api/monitor'
import Pagination from '@/components/Pagination/index.vue'
import { isEmpty } from '@/utils/utils'
import { constant } from 'lodash'
export default {
  components: { Pagination },
  data() {
    return {
      tableData: [],
      dialogFlag: false,
      listQuery: { page: 1, limit: 20 },
      pickerTime: [],
      total: 0,
      loading: false,
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      }
    }
  },
  mounted() {
    this.loading = true
    this.getList()
    const end = new Date()
    const start = new Date()
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
    this.pickerTime = [this.dateFormat(start), this.dateFormat(end)]
  },
  methods: {
    async getList() {
      const query = Object.assign({}, this.listQuery)
      if (!isEmpty(this.pickerTime)) {
        query.startTime = this.pickerTime[0]
        query.endTime = this.pickerTime[1]
      }
      await selectMonitorLinkRecordCount(query).then((res) => {
        this.tableData = res.data.items
        this.total = res.data.total
        this.loading = false
      })
    },
    async exportExcel() {
      let startTime = ''
      let endTime = ''
      if (!isEmpty(this.pickerTime)) {
        startTime = this.pickerTime[0]
        endTime = this.pickerTime[1]
      }
      window.location.href = '/v1/admin/monitor/exportExcel?&startTime=' + startTime + '&endTime=' + endTime
    },
    exportExcelFun() {
      if (isEmpty(this.pickerTime)) {
        this.$message({
          message: '请选择时间',
          type: 'warning'

        })
      } else {
        this.exportExcel()
      }
    },
    dateFormat(date) {
      const year = date.getFullYear()
      const month = this.showTime(date.getMonth() + 1)
      const day = this.showTime(date.getDate())
      return year + '-' + month + '-' + day
    },
    showTime(t) {
      const time = t > 10 ? t : '0' + t
      return time
    },
    dateChange() {
      this.getList()
    }
  }
}
</script>
